import Vue from "vue";
import Vuex from "vuex";
//import { clone } from "ramda";
Vue.use(Vuex);
const state = {
  database: {},
  mapFilters: {
    services: [],
    countries: [],
    regions: [],
    operators: []
  }
};
export const mutations = {
  createDatabase(state, data) {
    state.database = data;
  },
  resetMapFilters(state) {
    Object.keys(state.mapFilters).forEach(key => {
      state.mapFilters[key] = [];
    });
  }
};
export const getters = {
  selectAllFrom: table => {
    if (state.database.hasOwnProperty(table)) {
      return state.database[table];
    } else return {};
  },
  mapFilters: () => {
    //const obj = clone({}, state.mapFilters);
    return state.mapFilters;
  }
};
export default new Vuex.Store({
  state,
  getters,
  mutations
});
